import { render, staticRenderFns } from "./JEncryptDemo.vue?vue&type=template&id=70021985"
import script from "./JEncryptDemo.vue?vue&type=script&lang=js"
export * from "./JEncryptDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports